import { dateFormat } from '@/utils/dateFormat';
import { executionStatusGroup } from '@/model/invoiceMgr';

const commonFormatter = (v) => {
  if (!v && v !== 0) {
    return '--';
  }
  return v;
};

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

function setExpandTbCols () {
  let commonCols = [
    {
      tooltip: true,
      title: '商品图片',
      width: 100,
      field: 'image',
      slots: {
        default: ({ row }, h) => {
          let previewLists = (row.image.split(',') || []).map(url => url.endsWith('.heic') ? `${url}?imageView2/2/w/800/h/800` : url) || [];
          const actions = previewLists && previewLists.length ? [
            <div class='cellContainer'>
              <el-image fit='cover' preview-src-list={previewLists} referrer-policy='unsafe-url' z-Index={0} style={'width:40px;height:40px;'} src={`${previewLists[0]}?imageView2/2/w/40/h/40`} ></el-image>
            </div>,
          ] : [<div>--</div>];
          return [h('div', actions)];
        },
      },
    },
    {
      title: '商品编码',
      field: 'skuCode',
      showOverflow: true,
      width: 160,
      tooltip: true,
    },
    {
      title: '商品名称',
      field: 'goodsName',
      showOverflow: true,
      width: 180,
      tooltip: true,
    },
    {
      title: '品牌名称',
      field: 'brandName',
      showOverflow: true,
      tooltip: true,
    },
    {
      title: '规格',
      field: 'specification',
      showOverflow: true,
      tooltip: true,
    },
    {
      title: '型号',
      field: 'model',
      showOverflow: true,
      tooltip: true,
    },
    {
      title: '生产商',
      field: 'manufacturer',
      showOverflow: true,
      tooltip: true,
    },
    {
      title: '厂家编码',
      field: 'factoryCode',
      showOverflow: true,
      tooltip: true,
    },
    {
      title: '发货数量',
      field: 'quantity',
      showOverflow: true,
      width: 80,
      tooltip: true,
    },
    {
      title: '是否医疗件',
      field: 'medicalFlag',
      showOverflow: true,
      width: 80,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue ? '是' : '否';
      },
    },
    {
      title: '注册证号',
      field: 'certificateNumber',
      showOverflow: true,
      width: 150,
      tooltip: true,
    },
  ];

  commonCols.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return commonCols;
}

export function setOrderTableColumns (type = 0) {
  const orderTableColumns = [
    {
      type: 'expand',
      width: '50px',
      fixed: 'left',
      slots: {
        header: (_, h) => {
          let className = this.isExpand !== 3 ? 'allExpandIcon vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          let name = this.isExpand !== 3 ? 'vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          return [h('div', [<i name={name} class={className} style='cursor: pointer;font-size: 16px;' onClick={() => this.handleToggleExpand()}></i>])];
        },
        content: ({ row }, h) => {
          if (row.deliveryGoodsList?.length) {
            return [
              h('vxe-grid', {
                style: {
                  'z-index': 10,
                  'margin-left': '50px',
                  'margin-right': '100px',
                  'margin-top': '10px',
                  'margin-bottom': '10px',
                },
                props: {
                  align: 'center',
                  resizable: true,
                  stripe: false,
                  border: true,
                  autoResize: true,
                  showHeader: true,
                  showOverflow: true,
                  maxHeight: '500px',
                  size: 'mini',
                  data: row.deliveryGoodsList || [],
                  columns: setExpandTbCols(type, row, this),
                },
              }),
            ];
          }
        },
      },
    },
    {
      title: '发货单号',
      field: 'code',
      showOverflow: true,
      width: 160,
      tooltip: true,
    },
    {
      title: '发货状态',
      field: 'status',
      showOverflow: true,
      width: 150,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return convertToName(executionStatusGroup, cellValue);
      },
    },
    {
      title: '物流信息',
      field: 'logisticsList',
      showOverflow: true,
      width: 220,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue?.length ? `${cellValue[0].logisticsCompanyName}_${cellValue[0].code}` : '--';
      },
    },
    {
      title: '发货商品',
      field: 'deliveryGoodsList',
      showOverflow: true,
      width: 220,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue?.length ? cellValue.map(item => `${item.goodsName}*${item.model}*${item.quantity}`).join(';') : '--';
      },
    },
    {
      title: '客户名称',
      field: 'customerName',
      showOverflow: true,
      width: 200,
      tooltip: true,
    },
    {
      title: '销售订单号',
      field: 'orderCode',
      showOverflow: true,
      width: 160,
    },
    {
      title: '销售合同号',
      field: 'contractCode',
      showOverflow: true,
      width: 160,
    },
    {
      title: '收货人',
      field: 'receiverName',
      showOverflow: true,
      width: 150,
      tooltip: true,
    },
    {
      title: '更新时间',
      field: 'lastUpdateTime',
      showOverflow: true,
      width: 180,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '操作',
      fixed: 'right',
      showOverflow: false,
      width: '80px',
      slots: {
        default: ({ row }, h) => {
          let actions = [];
          actions.push(
            <span class='table-action' onClick={() => this.handleDetail(row)}>查看</span>,
          );
          return [h('div', actions)];
        },
      },
    },
  ];

  orderTableColumns.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return orderTableColumns;
}
